import * as React from "react";
import styled, { css } from "../../../styled";
import { CS } from "../../../styles";
import Transition from "react-transition-group/Transition";
import { FaTimes } from "react-icons/fa";
import shortid from "shortid";
const Wrapper = styled("div") `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  padding: 35px 20px;
  transition: 0.23s all;
  background: rgba(0, 0, 0, 0.7);
  overflow-y: ${({ active, level }) => (active || (level || 1) > 1 ? "scroll" : "hidden")};
  ${({ theme, fullScreenBelowSm }) => !fullScreenBelowSm
    ? css ``
    : css `
          overflow-x: hidden;
          @media (max-width: ${theme.breakpoints.sm}px) {
            padding: 0;
          }
        `}
`;
const InnerWrapper = styled("div") `
  position: fixed;
  top: 0;
  left: 0;
  right: 15px;
  bottom: 0;
  z-index: 0;
  background: transparent;
  @media (min-width: 1200px) {
    margin-right: 20px;
  }
`;
const Main = styled("div") `
  position: relative;
  background: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
  border-radius: 3px;
  margin: ${({ alignTop }) => (alignTop ? "50px auto auto auto" : "auto")};
  width: 100%;
  max-width: ${({ width, theme }) => typeof width === "number" ? width : theme.breakpoints[width]}px;
  transform: translateY(55px);
  transition: 0.23s all;
  ${CS.shadow.med.two};
  ${({ offsetCenterHorizontal }) => offsetCenterHorizontal && `transform: translateX(${offsetCenterHorizontal}px)`};
  ${({ theme, fullScreenBelowSm }) => !fullScreenBelowSm
    ? css ``
    : css `
          @media (max-width: ${theme.breakpoints.sm}px) {
            width: 100%;
            max-width: 100%;
            border-radius: 0;
            min-height: 100%;
          }
        `}
  ${({ active }) => !active
    ? css ``
    : css `
          transform: initial;
        `}
  > * {
    &:last-child {
      border-bottom-right-radius: 3px;
      border-bottom-left-radius: 3px;
    }
  }
`;
const CloseButton = styled("div") `
  ${CS.flex.center};
  cursor: pointer;
  position: absolute;
  top: -10px;
  right: -10px;
  height: 32px;
  width: 32px;
  border-radius: 30px;
  background: ${(props) => props.theme.colors.text};
  color: ${(props) => props.theme.colors.background};
  z-index: 1;
  ${({ theme, fullScreenBelowSm }) => !fullScreenBelowSm
    ? css ``
    : css `
          @media (max-width: ${theme.breakpoints.sm}px) {
            padding-top: 4px;
            padding-right: 4px;
          }
        `}
`;
const modalTransition = {
    entering: {
        display: "flex",
        opacity: 0,
    },
    entered: {
        display: "flex",
        opacity: 1,
    },
    exiting: {
        display: "flex",
        opacity: 0,
    },
    exited: {
        display: "none",
        opacity: 0,
    },
};
function activeModalGet() {
    window.activeModals = window.activeModals || [];
    return window.activeModals;
}
function activeModalLength() {
    return activeModalGet().length;
}
function activeModalAdd(id) {
    const active = activeModalGet();
    const index = active.indexOf(id);
    if (index === -1) {
        active.push(id);
    }
}
function activeModalRemove(id) {
    const active = activeModalGet();
    const index = active.indexOf(id);
    if (index !== -1) {
        active.splice(index, 1);
    }
}
function bodyScrollHide(scrollRoot) {
    const root = scrollRoot || document.body;
    if (root.className.indexOf("modal-active") !== -1)
        return;
    root.classList.add("modal-active");
    const scrollBarWidth = window.innerWidth - root.clientWidth;
    const st = Math.max(window.pageYOffset, document.body.scrollTop, document.documentElement.scrollTop, 0);
    root.style.overflow = "hidden";
    root.style.position = "fixed";
    root.style.top = `${-st}px`;
    root.style.paddingRight = `${scrollBarWidth}px`;
    // root.style.overflowY = "hidden";
}
function bodyScrollShow(scrollRoot) {
    const root = scrollRoot || document.body;
    if (root.className.indexOf("modal-active") === -1)
        return;
    root.classList.remove("modal-active");
    const scrollY = document.body.style.top;
    root.style.overflow = "";
    root.style.position = "";
    root.style.top = ``;
    root.style.paddingRight = ``;
    // root.style.overflowY = "hidden";
    window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
}
export class Modal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onEnter = () => {
            if (typeof window === "undefined")
                return;
            // If no active modals, hide the body scroll
            if (activeModalLength() === 0) {
                bodyScrollHide(this.props.scrollRoot);
            }
            activeModalAdd(this.id);
            // Scroll to top of modal
            setTimeout(() => {
                const modalWrapper = document.getElementById(this.id);
                try {
                    modalWrapper === null || modalWrapper === void 0 ? void 0 : modalWrapper.scroll({ top: 0, left: 0, behavior: "auto" });
                }
                catch (e) {
                    if (modalWrapper) {
                        modalWrapper.scrollTop = 0;
                        modalWrapper.scrollLeft = 0;
                    }
                }
            }, 50);
            // Set active class on modal
            /*
            setTimeout(() => {
              if (this.modalContent) {
                this.modalContent.classList.add("active");
              }
              else {
                setTimeout(() => {
                  this.modalContent?.classList.add("active");
                }, 100);
              }
            }, 100);
            */
        };
        this.onExit = () => {
            if (typeof window === "undefined")
                return;
            activeModalRemove(this.id);
            // If no active modals, show the body scroll
            if (activeModalLength() === 0) {
                bodyScrollShow(this.props.scrollRoot);
            }
            // this.modalContent?.classList.remove("active");
        };
        this.id = props.id || shortid.generate();
    }
    get modalContent() {
        return document.getElementById(`${this.id}-content`);
    }
    componentDidMount() {
        this.forceUpdate(); // probably for SSR
        if (this.props.active) {
            this.onEnter();
        }
    }
    componentWillUnmount() {
        this.onExit();
    }
    render() {
        const props = this.props;
        const { preventClose, persistChildren, wrapperClick, wrapperStyle, active } = props;
        const showCloseButton = props.closeButton === undefined ? true : props.closeButton;
        return (React.createElement(Transition, { key: "modal", in: active, timeout: 150 }, (state) => {
            if (state === "entering")
                this.onEnter();
            else if (state === "exiting")
                this.onExit();
            return (React.createElement(Wrapper, { id: this.id, level: props.level, active: active, onClick: wrapperClick, className: props.wrapperClassName, fullScreenBelowSm: props.fullScreenBelowSm, style: {
                    ...wrapperStyle,
                    ...modalTransition[state],
                } },
                React.createElement(InnerWrapper, { id: this.id + "inner", onMouseDown: (e) => {
                        if (state === "entered" && !preventClose && e.target) {
                            const t = e.target;
                            console.log(t.offsetLeft, t.clientLeft);
                            if (t.id && t.id === this.id + "inner") {
                                props.close();
                            }
                        }
                    } }),
                (persistChildren || (state !== "exited" && state !== "exiting")) && (React.createElement(Main, { ...props, id: `${this.id}-content`, active: props.active && state === "entered" },
                    showCloseButton && (React.createElement(CloseButton, { onClick: props.close, fullScreenBelowSm: props.fullScreenBelowSm },
                        React.createElement(FaTimes, null))),
                    props.children))));
        }));
    }
}
//# sourceMappingURL=index.js.map